import React, { useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Routes from "./Routes"
import "./App.css";
import { Link } from "react-router-dom";
import { RefContext } from "./lib/context"

function App() {

  const contactRef = useRef(null)
  const homeRef = useRef(null)
  const aboutRef = useRef(null)
  const SkillRef = useRef(null)
  const projectRef = useRef(null)

  const contactScroll = () => contactRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const homeScroll = () => homeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const aboutScroll = () => aboutRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })

  const skillScroll = () => SkillRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const projectScroll = () => projectRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return (


    <div className="App">
      <div className="Nav">
        <Navbar collapseOnSelect expand="lg" fixed="top" className="NavBar">
          <Link to="/" onClick={() => homeScroll()}>
            <Navbar.Brand className="font-weight-bold text-muted">
              <h3 className="logo">
                SB
              </h3>
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end" style={{ paddingRight: 50 }}>

            <Nav.Link onClick={aboutScroll}
              target="_blank" rel="noopener noreferrer" className="effect" style={{ color: '#d7d7d7', fontWeight: "bold" }}>About</Nav.Link>


            <Nav.Link onClick={skillScroll}
              target="_blank" rel="noopener noreferrer" className="effect" style={{ color: '#d7d7d7', fontWeight: "bold" }}>Skills</Nav.Link>

            <Nav.Link onClick={projectScroll}
              target="_blank" rel="noopener noreferrer" className="effect" style={{ color: '#d7d7d7', fontWeight: "bold" }}>Projects</Nav.Link>

            <Nav.Link onClick={contactScroll}
              target="_blank" rel="noopener noreferrer" className="effect" style={{ color: '#d7d7d7', fontWeight: "bold" }}>Contact</Nav.Link>

            <Nav activeKey={window.location.pathname}>
              <Nav.Link href="https://drive.google.com/file/d/1ZXn3AamkUAFWjGcGexbBCSt4nDjSjcJ5/view" target="_blank" rel="noopener noreferrer" className="effect" style={{ color: '#d7d7d7', fontWeight: "bold" }}>Resume</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
      <div>
        <RefContext.Provider value={{ contactRef, homeRef, aboutRef, SkillRef, projectRef, projectScroll, skillScroll, contactScroll, aboutScroll }}>
          <Routes />
        </RefContext.Provider>
      </div>
    </div>
  );
}

export default App;
